module.exports = __webpack_public_path__ + "img/HC2022-67.ea3d8f7d.jpg";